import { Box, FormControl, Grid, MenuItem, Select } from "@mui/material";
import Typography from "@mui/material/Typography";
import PropTypes from 'prop-types';


const Temperatura = ({ promptData, setPromptData }) => {
  const handleTemperatura = (event) => {
    const temperatura = event.target.value;

    setPromptData((prevData) => ({
      ...prevData,
      temperatura: Number(temperatura),
    }));
  };

  return (
    <Grid item xs={12}>
      <Box>
        <Typography
          sx={{ fontFamily: "Inter", fontSize: "1rem", fontWeight: "bold" }}
        >
          Temperatura:
        </Typography>
        {/**  <FormLabel sx={{ fontFamily: 'Inter', fontSize: '0.8rem' }}>
                Indica el número de niveles de desempeño que deseas incluir en tu rúbrica. Los niveles de desempeño permiten evaluar el grado de cumplimiento de los criterios por parte de los estudiantes.   

                </FormLabel>*/}
        <FormControl fullWidth>
          <Select
            labelId="select-subject"
            placeholder="Selecciona una temperatura"
            value={promptData.temperatura}
            id="select-subject"
            variant="standard"
            onChange={handleTemperatura}
            sx={{
              fontFamily: "Inter",
              fontSize: "14px",
              color: "#005559",
              "& fieldset": { borderColor: "#005559" },
              "&:before": { borderColor: "#005559" },
              "&:after": { borderColor: "#005559" },
            }}
          >
            <MenuItem value={"0.1"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.1
              </Typography>
            </MenuItem>
            <MenuItem value={"0.2"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.2
              </Typography>
            </MenuItem>
            <MenuItem value={"0.3"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.3
              </Typography>
            </MenuItem>
            <MenuItem value={"0.4"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.4
              </Typography>
            </MenuItem>
            <MenuItem value={"0.5"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.5
              </Typography>
            </MenuItem>
            <MenuItem value={"0.6"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.6
              </Typography>
            </MenuItem>
            <MenuItem value={"0.7"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.7
              </Typography>
            </MenuItem>
            <MenuItem value={"0.8"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.8
              </Typography>
            </MenuItem>
            <MenuItem value={"0.9"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                0.9
              </Typography>
            </MenuItem>
            <MenuItem value={"1"} sx={{ color: "#005559" }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "0.8rem" }}>
                1
              </Typography>
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
};

Temperatura.propTypes = {
  promptData: PropTypes.object.isRequired,
  setPromptData: PropTypes.func.isRequired,
};

export default Temperatura;
